import { useWindowSize } from "usehooks-ts";

const MOBILE_MAX_WIDTH = 800;

export const useIsMobileScreen = () => {
  const { width } = useWindowSize();

  return width <= MOBILE_MAX_WIDTH;
};
